export * from './get-cart-shipments';

export const Cart = {
  getCartShipments: require('./get-cart-shipments').getCartShipments,
  getCartSummary: require('./get-cart-summary').getCartSummary,
};
